import { render, staticRenderFns } from "./voucherInput.vue?vue&type=template&id=327a2f4e&scoped=true&"
import script from "./voucherInput.vue?vue&type=script&lang=js&"
export * from "./voucherInput.vue?vue&type=script&lang=js&"
import style0 from "./voucherInput.vue?vue&type=style&index=0&id=327a2f4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327a2f4e",
  null
  
)

/* custom blocks */
import block0 from "./voucherInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports